module.exports = __webpack_public_path__ + "static/media/Capa-WB43Premium.5d0a6351.PNG";